import useJwt from '@/auth/jwt/useJwt'

export default class ExpertoService {
  static getDashboard(params = {}) {
    return useJwt.get('/experto/dashboard', params)
  }

  static getSentMessages(userId) {
    return useJwt.get(`/experto/sent-messages?user_id=${userId}`)
  }

  static getAnsweredMessages(userId) {
    return useJwt.get(`/experto/answered-messages?user_id=${userId}`)
  }

  static getContactedMessages(userId) {
    return useJwt.get(`/experto/contacted-messages?user_id=${userId}`)
  }
}
